import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { setTextFilter, sortByEffectiveDate, sortByAmount, setStartDate, setEndDate, sortByPostedDate, searchByEntryNumber, searchByVendor, searchByPurpose, displayDivision } from '../../actions/filterActions';
import { startSetEntry } from '../../actions';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  }
});

export class EntriesFilters extends Component {

  state = {
    calenderFocused: null,
    // startDate: moment().startOf('year'),
    // endDate: moment().endOf('month'),
  };

  onDatesChange = ({ startDate, endDate }) => {
    this.props.setStartDate(startDate);
    this.props.setEndDate(endDate);
    // this.setState({
    //   startDate, endDate
    // }, () => this.props.startSetEntry({ startDate, endDate })); 
  }

  onFocusChange = (calenderFocused) => {
    this.setState({
      calenderFocused
    });
  }

  onTextChange = (e) => {
    this.props.setTextFilter(e.target.value);
  }

  onSetSortBy = (e) => {
    const criteria = e.target.value;
    switch (criteria) {
      case 'effectiveDate':
        return this.props.sortByEffectiveDate();
      case 'amount':
        return this.props.sortByAmount();
      case 'postedDate':
        return this.props.sortByPostedDate();
      default:
        return this.props.sortByEffectiveDate();
    }
  }

  onSetSearchBy = (e) => {
    const criteria = e.target.value;
    switch (criteria) {
      case 'purpose':
        return this.props.searchByPurpose();
      case 'entry_number':
        return this.props.searchByEntryNumber();
      case 'vendor':
        return this.props.searchByVendor();
      default:
        return this.props.searchByEntryNumber();
    }
  }

  onShowDivision = (e) => {
    this.props.displayDivision(e.target.value);
  }


  render() {
    const { classes } = this.props;
    return (
      <div>
        <DateRangePicker
          small
          startDate={this.props.filters.startDate}
          endDate={this.props.filters.endDate}
          onDatesChange={this.onDatesChange}
          endDateId='end'
          startDateId='start'
          focusedInput={this.state.calenderFocused}
          onFocusChange={this.onFocusChange}
          numberOfMonths={1}
          isOutsideRange={() => false}
          showClearDates
        />
        <TextField
          select
          margin="normal"
          className={classes.textField}
          label="Sort By"
          value={this.props.filters.sortBy}
          onChange={this.onSetSortBy}
        >
          {[{ label: 'Effective Date', value: 'effectiveDate' }, { label: 'Posted Date', value: 'postedDate' }].map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          margin="normal"
          className={classes.textField}
          label="Search By"
          value={this.props.filters.searchBy}
          onChange={this.onSetSearchBy}
        >
          {[{ label: 'Entry Number', value: 'entry_number' }, { label: 'Purpose', value: 'purpose' }].map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          id="name"
          type="search"
          className={classes.textField}
          label={this.props.filters.searchBy}
          value={this.props.filters.text}
          onChange={this.onTextChange}
          margin="normal"
        />

        <TextField
          select
          margin="normal"
          className={classes.textField}
          label="Division"
          value={this.props.filters.showDivison}
          onChange={this.onShowDivision}
        >
          {[{ division_code: 'all', name: 'All' }, ...this.props.divisions].map(division => (
            <MenuItem key={division.division_code} value={division.name}>
              {division.name}
            </MenuItem>
          ))}
        </TextField>

      </div>
    );
  }
}

const mapStateToProps = ({ filters, divisions }) => {
  return {
    filters, divisions
  };
};

const mapDispatchToProps = (dispatch) => ({
  setTextFilter: text => dispatch(setTextFilter(text)),
  sortByEffectiveDate: () => dispatch(sortByEffectiveDate()),
  sortByAmount: () => dispatch(sortByAmount()),
  setStartDate: startDate => dispatch(setStartDate(startDate)),
  sortByPostedDate: () => dispatch(sortByPostedDate()),
  setEndDate: endDate => dispatch(setEndDate(endDate)),
  searchByEntryNumber: () => dispatch(searchByEntryNumber()),
  searchByVendor: () => dispatch(searchByVendor()),
  searchByPurpose: () => dispatch(searchByPurpose()),
  displayDivision: division => dispatch(displayDivision(division)),
  startSetEntry: ({ startDate, endDate }) => dispatch(startSetEntry({ startDate, endDate }))
});

export default compose(
  withStyles(styles, {
    name: 'EntriesFilters',
  }), connect(mapStateToProps, mapDispatchToProps))(EntriesFilters);



// WEBPACK FOOTER //
// ./src/components/entries/EntriesFilters.js